import type { Media } from "@/types/media";
import { movies } from "@/mocks/movies";
import { tvShows } from "@/mocks/tvShows";

export const allMedia: Media[] = [...movies, ...tvShows];

export const movieGenres = [
  "动作",
  "科幻",
  "爱情",
  "悬疑",
  "剧情",
  "喜剧",
  "奇幻",
  "历史",
  "战争",
  "冒险",
  "犯罪",
  "家庭",
  "武侠",
  "运动",
];

export const tvGenres = [
  "古装",
  "都市",
  "剧情",
  "犯罪",
  "科幻",
  "家庭",
  "喜剧",
  "武侠",
  "青春",
  "商战",
  "医疗",
  "历史",
  "战争",
  "冒险",
  "爱情",
  "奇幻",
  "悬疑",
];

export const regions = [
  "中国大陆",
  "美国",
  "香港",
  "日本",
  "韩国",
  "英国",
  "德国",
  "加拿大",
];

export const years = [2025, 2024, 2023, 2022, 2021];

export type SortKey = "default" | "newest" | "hot";

export interface MediaFilter {
  genre?: string;
  region?: string;
  year?: string;
  keyword?: string;
}

export function getMediaById(id: string): Media | undefined {
  return allMedia.find((item) => item.id === id);
}

export function searchMedia(keyword: string, kind?: "movie" | "tv"): Media[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return allMedia.filter((item) => {
    if (kind && item.kind !== kind) return false;
    const haystack = [
      item.title,
      item.titleEn,
      item.director,
      item.region,
      ...item.genres,
      ...item.cast,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function filterMedia(list: Media[], filter: MediaFilter): Media[] {
  return list.filter((item) => {
    if (filter.genre && !item.genres.includes(filter.genre)) return false;
    if (filter.region && item.region !== filter.region) return false;
    if (filter.year && String(item.year) !== filter.year) return false;
    return true;
  });
}

export function sortMedia(list: Media[], sort: SortKey): Media[] {
  const copy = [...list];
  if (sort === "newest") {
    copy.sort((a, b) => b.year - a.year);
  } else if (sort === "hot") {
    copy.sort((a, b) => b.views - a.views);
  }
  return copy;
}

export function getRelated(item: Media, count = 3): Media[] {
  const sameKind = allMedia.filter((m) => m.id !== item.id && m.kind === item.kind);
  const scored = sameKind
    .map((m) => ({
      media: m,
      score: m.genres.filter((g) => item.genres.includes(g)).length,
    }))
    .sort((a, b) => b.score - a.score || b.media.rating - a.media.rating);
  return scored.slice(0, count).map((s) => s.media);
}

export function topByViews(kind: "movie" | "tv", count = 5): Media[] {
  return allMedia
    .filter((m) => m.kind === kind)
    .sort((a, b) => b.views - a.views)
    .slice(0, count);
}

export function latestByYear(kind: "movie" | "tv", count = 6): Media[] {
  return allMedia
    .filter((m) => m.kind === kind)
    .sort((a, b) => b.year - a.year || b.rating - a.rating)
    .slice(0, count);
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return String(views);
}